/**
 * =============================================================================
 * theme.js
 * =============================================================================
 * Entry point for all theme Javascript.
 * 
 * Before launching a site, consider what imports you actually need - i.e. which
 * parts of Bootstrap, which vendor JS imports, which Bootstrap plugins, etc.
 * =============================================================================
 */

// Imports from node_modules, installed via 'yarn add ...'
import * as bootstrap from 'bootstrap'; // Bootstrap (~97Kb)
import Swiper, { Navigation, Pagination, Autoplay, Thumbs, Lazy, Manipulation } from 'swiper'; // Swiper (~??Kb)
import 'waypoints/lib/noframework.waypoints.min.js'; // Waypoints (intersection observer utility) (~10Kb)
import Cookies from 'js-cookie'; // Cookies.js (~2Kb)
import AOS from 'aos'; // Animate on Scroll (~14Kb)

Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Lazy, Manipulation]);

// Export for others scripts to use by attaching to the window
window.bootstrap = bootstrap;
window.Swiper = Swiper;
window.Cookies = Cookies;

// Initialisation
AOS.init({
  once: true
});

// Imports from this folder - MP-specific
import MP from './mp';

import Account from './account';
import Animation from './animation';
import Blog from './blog';
import BundleBuilder from './bundle-builder';
import Cart from './cart';
import Collection from './collection';
import CookieBar from './cookie-bar';
import ContentCollapse from './content-collapse';
import CountdownManager from './countdown-manager';
import Facets from './facets';
import FragranceFinder from './fragrance-finder';
import FGWP from './fgwp';
import GiftWrap from './gift-wrap';
import Localization from './localization';
import Nav from './nav';
import NewsletterPopup from './newsletter-popup';
import OffcanvasCartSwiper from './offcanvas-cart-swiper';
import OffcanvasProgressBar from './offcanvas-progress-bar';
import ProductFormManager from './product-form-manager';
import ProductModels from './product-models';
import RebuyProductTile from './rebuy-product-tile';
import RecentlyViewed from './recently-viewed';
import StockistLocator from './stockist-locator';
import WellnessFinder from './wellness-finder';

import ProductTile from "./product-tile";
customElements.define('product-tile', ProductTile);

// Export for others scripts to use by attaching to the window
MP.Extensions.Account = Account;
MP.Extensions.Animation = Animation;
MP.Extensions.Blog = Blog;
MP.Extensions.BundleBuilder = BundleBuilder;
MP.Extensions.Cart = Cart;
MP.Extensions.Collection = Collection;
MP.Extensions.CookieBar = CookieBar;
MP.Extensions.ContentCollapse = ContentCollapse;
MP.Extensions.CountdownManager = CountdownManager;
MP.Extensions.Facets = Facets;
MP.Extensions.FragranceFinder = FragranceFinder;
MP.Extensions.FGWP = FGWP;
MP.Extensions.GiftWrap = GiftWrap;
MP.Extensions.Localization = Localization;
MP.Extensions.OffcanvasCartSwiper = OffcanvasCartSwiper;
MP.Extensions.OffcanvasProgressBar = OffcanvasProgressBar;
MP.Extensions.ProductFormManager = ProductFormManager;
MP.Extensions.ProductModels = ProductModels;
MP.Extensions.Nav = Nav;
MP.Extensions.NewsletterPopup = NewsletterPopup;
MP.Extensions.RebuyProductTile = RebuyProductTile;
MP.Extensions.RecentlyViewed = RecentlyViewed;
MP.Extensions.StockistLocator = StockistLocator;
MP.Extensions.WellnessFinder = WellnessFinder;

// Global functions
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Kickoff!
window.MP = Object.assign(MP, window.MP);
MP.init();